import insurerRatingsConfig from '@/../config/insurer-ratings.json';

/** Category definition with label and description */
export interface CategoryDefinition {
	label: string;
	description: string;
}

/** Insurer rating data from config (0-5 star scale) */
export interface InsurerRatingConfig {
	name: string;
	overallRating: number;
	categoryRatings: Record<string, number>;
}

/** Ratings config structure */
export interface RatingsConfig {
	categories: Record<string, CategoryDefinition>;
	ratings: Record<string, InsurerRatingConfig>;
}

/** Get validated ratings config */
export const getRatingsConfig = (): RatingsConfig => {
	const config = insurerRatingsConfig as RatingsConfig;

	// Runtime validation
	if (!config.categories || !config.ratings) {
		throw new Error('Invalid insurer ratings config: missing categories or ratings');
	}

	return config;
};

/** Get rating data for a specific insurer using image_key */
export const getInsurerRating = (imageKey: string): InsurerRatingConfig | null => {
	const config = getRatingsConfig();
	return config.ratings[imageKey] || null;
};

/** Get all category definitions */
export const getCategoryDefinitions = (): Record<string, CategoryDefinition> => {
	return getRatingsConfig().categories;
};
